import { IconMapLocation16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';

import * as styles from './GeoSwitcher.css';

interface IGeoSwitcherProps {
  title: string;
  onClick(): void;
}

export const GeoSwitcher: React.FC<IGeoSwitcherProps> = ({ title, onClick }) => {
  // Замыкаем тайтл, чтобы не менять, пока не перезагрузится страница при смене региона
  const regionTitle = React.useRef(title);

  return (
    <div className={styles['wrapper']}>
      <button onClick={onClick} className={styles['button']}>
        <IconMapLocation16 color="current_color" /> <span className={styles['text']}>{regionTitle.current}</span>
      </button>
    </div>
  );
};
